/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { getCellColor, getCellImage, getCellStatus } from '../../../utils/FormatFunctions';
import { useAuth } from '../../../providers/auth';

export function ContentsCategoriesPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/categories`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'image', label: 'Imagem' },
    { name: 'name', label: 'Nome' },
    { name: 'hex_color', label: 'Cor' },
    { name: 'position', label: 'Ordem' },
    { name: 'status', label: 'Status' },
  ];
  const groupIds = user?.group?.id;

  return (
    <Box>
      <PageTitle>Categorias</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 7 && groupIds !== 3}
        loading={loading}
        rowActions={{
          show: false,
          edit: groupIds !== 7 && groupIds !== 3,
          delete: groupIds !== 3 && groupIds !== 5,
        }}
        formatColum={[
          {
            field: 'image',
            formatField: getCellImage,
          },
          {
            field: 'hex_color',
            formatField: getCellColor,
          },
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
